module.exports = __webpack_public_path__ + "img/Dino Rex.jpg";